import { Component, OnInit, ViewChild } from "@angular/core";
import { FacilityService } from "../../services/administration/facilities/facilities.service";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IFacilityData } from "../../interfaces/administration/facilityData";

@Component({
  selector: "create-facility-component",
  templateUrl: "./create-facility.component.html",
  styles: [
    `
      .button-container {
        display: flex !important;
        justify-content: space-between !important;
      }
    `,
  ],
})
export class CreateFacilityComponent implements OnInit {
  title = "Facilities";
  public facilityForm: FormGroup;
  public validationMessages: string[] = [];

  constructor(
    private service: FacilityService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.facilityForm = this.fb.group({
      name: ["", Validators.required],
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    this.validationMessages = this.service.validate(this.facilityForm);
    if (this.validationMessages.length > 0) {
      //smooth scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    this.validationMessages = [];

    if (this.facilityForm.valid) {
      let facility: IFacilityData = this.facilityForm.value;
      this.service.createFacility(facility).subscribe((result) => {
        if (result) {
          this.router.navigate([
            "/administration/facilities/edit/" + result.id,
          ]);
        }
      });
    }
  }

  cancel() {
    this.router.navigate(["/administration/facilities"]);
  }
}
